<template>
  <kst-page-print-details page-footer
    class="has-text-weight-semibold ks-font-lucida-console print-thermal-size"
    @init="handleInit"
  >
    <template #page-footer="{ label, timestamp }">
      {{ label }} {{ timestamp }}
    </template>

    <Company class="block mb-6" :data="companyData" :customData="details"/>
    <Details :details="details"/>

    <kst-divider class="has-background-black"/>
    <Items :items="details.Items"/>

    <kst-divider class="has-background-black"/>
    <Total class="mb-5" :details="details"/>

    <Footer :details="details"/>
  </kst-page-print-details>
</template>

<script>
import Model from "../PurModel.js";
import Services from "../../../services/Api/PurchaseServices.js";

import Details from "./PurPT_Details.vue";
import Footer from "./PurPT_Footer.vue";
import Total from "./PurPT_Total.vue";
import Items from "./PurPT_Items.vue";
import Company from "../../Company/RelatedPrintThermal/CpPT.vue";

export default {
  components: {
    Details,
    Footer,
    Items,
    Total,
    Company
  },
  data: () => ({
    Model,
    companyData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintThermalData(id);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.companyData = data.CompanyDetails;
      this.details = data.Details;

      Model.PrintThermal.updateDetails(this.details);

      for (const item of this.details.Items) {
        Model.updateItem(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>

<style scoped lang="css" src="./_layout.css"/>